import { getAuthHeader } from '.';
import { ROOT_URL } from '../utils/constants';
import type { Farm } from '../models/Farm';

class FarmAddressApi {
  static async getFarmsForUser(search: string): Promise<Farm[]> {
    const [headers, userDetails] = await getAuthHeader();
    const response = await fetch(
      `${ROOT_URL}/api/farms/${userDetails?.userId}?view=${search}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: headers,
      },
    );
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async getFarm(farmId: number): Promise<Farm> {
    const [headers, userDetails] = await getAuthHeader();
    const response = await fetch(
      `${ROOT_URL}/api/farms/${userDetails?.userId}/${farmId}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: headers,
      },
    );
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async createFarm(farm: Farm): Promise<Farm> {
    const [headers, userDetails] = await getAuthHeader();
    const response = await fetch(
      `${ROOT_URL}/api/farms/${userDetails?.userId}`,
      {
        method: 'POST',
        credentials: 'include',
        headers: headers,
        body: JSON.stringify(farm),
      },
    );
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async updateFarm(farmId: number, farm: Farm): Promise<Farm> {
    const [headers, userDetails] = await getAuthHeader();
    const response = await fetch(
      `${ROOT_URL}/api/farms/${userDetails?.userId}/${farmId}`,
      {
        method: 'PUT',
        credentials: 'include',
        headers: headers,
        body: JSON.stringify(farm),
      },
    );
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async deleteFarm(farmId: number) {
    const [headers, userDetails] = await getAuthHeader();
    const response = await fetch(
      `${ROOT_URL}/api/farms/${userDetails?.userId}/${farmId}`,
      {
        method: 'DELETE',
        credentials: 'include',
        headers: headers,
      },
    );
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return true;
  }
}

export default FarmAddressApi;
